'use strict';

// EXPORTS //

module.exports = require( './matrix.js' );
module.exports.raw = require( './matrix.raw.js' );



//////////////////
// WEBPACK FOOTER
// ./~/dstructs-matrix/lib/index.js
// module id = 1741
// module chunks = 0